// @flow strict

import { NotificationChannel } from 'services/Notifications/types';

export const getChannelKey = (channel: NotificationChannel) => `${channel}Notification`;
